module.exports = __webpack_public_path__ + "img/fdl_xia2.77a31578.png";